import { isLink } from './isLink'

export const replaceLink = (link: string) => {
  if (isLink(link)) {
    return `<a target='_blank' href='${link}' data-readonly>${link}</a>`
  }
  return link
}
